import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnInit,
} from '@angular/core';
import {
    Answer,
    FilterFieldDefinition,
    PossibleValue,
} from '@wdx/clmi/clmi-swagger-gen';
import { TranslationsService } from '@wdx/shared/utils';
import { map, Observable } from 'rxjs';
import { ExtendedFieldDefinitionOption } from '../../../../../../models/extended-field-definition-option.model';
import { FilterDataItem } from '../../interfaces';
import { FilterDataProviderService } from '../../services/filter-data/filter-data-provider.service';

@Component({
    selector: 'clmi-filter-select',
    templateUrl: './filter-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FilterSelectComponent implements OnInit {
    private _definition: FilterFieldDefinition;
    @Input() set definition(value: FilterFieldDefinition) {
        this._definition = value;
        this.updateOptions();
    }

    @Input() formControlNameOrIndex: string | number;
    @Input() multiple = false;
    private _options?: PossibleValue[];
    @Input() set options(value: PossibleValue[]) {
        this._options = value;
    }
    options$: Observable<FilterDataItem[] | ExtendedFieldDefinitionOption[]>;

    private translationsService = inject(TranslationsService);

    constructor(
        private readonly filterDataProviderService: FilterDataProviderService,
    ) {}

    ngOnInit(): void {
        this.updateOptions();
    }

    private updateOptions() {
        this.options$ = this.filterDataProviderService
            .getData$(this._definition, this._options)
            .pipe(
                map((options) =>
                    (options as (FilterDataItem | Answer)[]).map((option) => ({
                        ...option,
                        value:
                            (option as FilterDataItem).value ||
                            (option as Answer).code,
                        label: this.translationsService.translateTokenisedString(
                            (option as FilterDataItem).label ||
                                (option as Answer).name,
                        ),
                    })),
                ),
            );
    }
}
